// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// helpers
import { getOptimisedImageUrl } from 'shared/helpers/utils';
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';
import { trackBrandNameClicked } from 'shared/layouts/DetailsPage/analytics';

// constants
import { TEXTS } from './texts';
import { BRAND_CLICK_TRACK_LOCATION } from 'shared/helpers/analytics/constants/pdpEvents';

// styles
import { Container, Name, Bio, ImageCtr, Image, Row } from './styles';

// defs
interface IAboutDesignerProps {
  designerData: {
    name: string;
    imgUrl: string;
    description: string;
  };
  actionURL?: string;
}

const IMAGE_WIDTH = 88;
const IMAGE_HEIGHT = 115;

function AboutDesigner({ designerData, actionURL }: IAboutDesignerProps) {
  if (isEmpty(designerData)) {
    return null;
  }

  const onBrandAboutusClicked = () => {
    storeAnalyticsDataInLocal({ brandTitleOrAboutUs: 'aboutus' });
  };
  const ImageTagComponent = (
    <Image
      src={getOptimisedImageUrl(designerData.imgUrl, {
        width: IMAGE_WIDTH * 2,
      })}
      alt={designerData.name}
      width={IMAGE_WIDTH}
      height={IMAGE_HEIGHT}
      onClick={() => trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.DESIGNER_IMAGE_CLICK)}
    />
  );
  const BrandLogoComponent = actionURL ? (
    <a href={actionURL} onClick={onBrandAboutusClicked} aria-label={designerData.name}>
      {ImageTagComponent}
    </a>
  ) : (
    ImageTagComponent
  );

  return (
    <Container data-test="about-designer" data-at="about-brand">
      <div className="designer-profile">
        <Name>{TEXTS.ABOUT(designerData.name)}</Name>
        <Row>
          <Bio>{designerData.description}</Bio>
          <ImageCtr>{BrandLogoComponent}</ImageCtr>
        </Row>
      </div>
    </Container>
  );
}

export default memo(AboutDesigner);
